import { GroupFromIndex } from '@app/core/types/users';
import { MrtTable } from '@mi-front/ui';
import { UseQueryResult } from '@tanstack/react-query';
import { useIntl } from 'react-intl';

interface Props {
  query: UseQueryResult<GroupFromIndex[], Error>;
}

export const AdminGroupsList = (props: Props) => {
  const { formatMessage } = useIntl();
  const { query } = props;

  const data = query.data ?? [];

  return (
    <MrtTable
      navigateToOnClick={(id) => `/admin/groups/${id}`}
      enableNavigateAction
      columns={[
        {
          header: formatMessage({
            id: 'common.text.name',
            defaultMessage: 'Nombre',
          }),
          size: 100,
          accessorKey: 'name',
        },
        {
          header: formatMessage({
            id: 'admin.groups.listScreen.usersCountHeader',
            defaultMessage: '# Usuarios',
          }),
          size: 50,
          accessorKey: 'usersCount',
          Cell: ({ row: { original } }) => original.usersCount,
        },
      ]}
      data={data}
      enableColumnFilters={false}
      state={{
        isLoading: query.isLoading,
      }}
    />
  );
};
